import { borderRadius, opacityValues, fontSizeValues } from "@atlas-int/tokens";

const ClickIndicator = () => {
  return (
    <div
      data-download-exclude
      style={{
        display: "flex",
        position: "absolute",
        top: 5,
        left: 5,
        backgroundColor: `rgba(255,255,255,${opacityValues.hover})`,
        borderRadius: borderRadius.base,
      }}
    >
      <img
        alt="instruction: click on a node to see related products "
        style={{ height: "40px" }}
        src="/click.png"
      />
      <div style={{ width: "140px", fontSize: fontSizeValues.lg }}>
        Click on a node to see related products
      </div>
    </div>
  );
};
export default ClickIndicator;
